import React from 'react';
import useLangTranslation from '../../../../customHooks/languageProvider';
import ImageSucces from '../../../../../assets/images/image-success.png'; 
import Loader from '../../../../../setup/Loader/LoaderIndicator';

const SignUpSuccess = ({ loader, handleGotItAfterSingUpSuccessButton }) => {
    const { getLangTranslation } = useLangTranslation();
    return (
        <div className="container">
            <div className="auth-wrapper">
                <div className="auth-inner text-center">
                    <div>
                        <img src={ImageSucces} alt='' />
                    </div>
                    <h5 className="text-center mb-9">
                        {/* An email was sent to your registered email address <br />with your Pin Code */}
                        <b>{getLangTranslation('CONG_SIGN_UP_PROCESS_DONE_TEXT', 'Congratulation your Sign Up process is done!')}</b>
                    </h5>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleGotItAfterSingUpSuccessButton()}
                        disabled={loader}
                    >
                        {
                            loader ? (
                                <Loader height={20} width={100} />
                            ) : (
                                <span className="btn-upper-case text-white">{getLangTranslation('PAIRING_CODE_NEXT', 'Next')}</span>
                            )
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SignUpSuccess